import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import PaymentTypeContainer from "../../Entity/Entities/Payment/PaymentType/PaymentTypeContainer";

class DashboardWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const dashboardRootObj = {
      '/app/dashboard/overview': 0,
      '/app/dashboard/messages': 1,
      '/app/dashboard/statements': 2,
      '/app/dashboard/charges': 3,
      '/app/dashboard/unused': 4,
      // '/app/dashboard/receivables': 4,
      // '/app/dashboard/payables': 5,
      '/app/dashboard/contracts': 5,
      '/app/dashboard/tasks': 6,
      '/app/dashboard/activities': 7,
      '/app/dashboard/notifications': 8
    }

    const selectedTabIndexSession = dashboardRootObj[this.component.props.location.pathname];
    
    this.component.props.dispatch({
      type: Constants.PAGE_DASHBOARD_UPDATE_SWITCH_TAB,
      payload: {
        index: selectedTabIndexSession
      }
    });

    const payloadStatements: any = {
      sortBy: "+firstDate",
      offset: 0,
      removed: 0,
      isSent: Number(false),
      afterInvoiceNumberStartDate: true,
      isSnoozed: 0
    };

    this.component.props.dispatch({
      type: Constants.GLOBAL_FINANCIAL_STATEMENTS_SAVE_LIST,
      payload: {
        ...payloadStatements
      },
      onSuccess: (data) => {
        this.component.props.dispatch({
          type: Constants.GLOBAL_SAVE_NOTSENT_STATEMENTS_COUNT,
          payload: {
            dashboardStatementsCount: data.count
          }
        })
      }
    });

    const payloadForUnusedPayments: any = {
      firstItem: 0,
      lastItem: 0,
      agencyBankAccount: "all",
      filterValue: "",
      removed: 0,
      isAfterStartDate: 1, // do not fetch charges before start date,
      dashboard: 1,
      isSnoozed: 0,
      removeType: [PaymentTypeContainer.pickIdFromLabel("Savings_account"), PaymentTypeContainer.pickIdFromLabel("Settlement")]
    };
    this.component.props.dispatch({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST,
      payload: {
        ...payloadForUnusedPayments
      },
      onSuccess: (data) => {
        this.component.props.dispatch({
          type: Constants.GLOBAL_SAVE_UNUSED_PAYMENTS_COUNT,
          payload: {
            dashboardPaymentsCount: data.count
          }
        })
      }
    });

    const payloadForUnpaidReceivableCharges: any = {
      firstItem: 0,
      paid: 0, //unpaid charges
      isBeforeStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      isSnoozed: 0,
      chargeClassId: 1
    };
  
    this.component.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payloadForUnpaidReceivableCharges
      },
      onSuccess: (data) => {
        this.component.props.dispatch({
          type: Constants.GLOBAL_SAVE_UNPAID_RECEIVABLE_CHARGES_COUNT,
          payload: {
            dashboardReceivableChargesCount: data.count
          }
        })
      }
    });

    const payloadForUnpaidPayableCharges: any = {
      firstItem: 0,
      paid: 0, //unpaid charges
      isBeforeStartDate: 1, // do not fetch charges before start date
      hideZeroPayout: 1, // do not fetch payout charges with 0 amount
      isOverdue: 1, // charges not paid in time
      isSnoozed: 0,
      chargeClassId: 2
    };
  
    this.component.props.dispatch({
      type: Constants.GLOBAL_CHARGES_SAVE_LIST,
      payload: {
        ...payloadForUnpaidPayableCharges
      },
      onSuccess: (data) => {
        this.component.props.dispatch({
          type: Constants.GLOBAL_SAVE_UNPAID_PAYABLE_CHARGES_COUNT,
          payload: {
            dashboardPayableChargesCount: data.count
          }
        })
      }
    });

    const payloadTasks: any = {
      offset: 0,
      eventTypeIds: [35, 38], // task || incident
      removed: 0,
      // executorId: this.component?.props?.app?.session?.user?.id,
      includeActivitiesTasks: false,
      isSnoozed: 0,
      reacted: 0
    };

    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payloadTasks
      },
      onSuccess: (data) => {
        this.component.props.dispatch({
          type: Constants.GLOBAL_SAVE_NOTFINISHED_TASKS_COUNT,
          payload: {
            dashboardTasksCount: data.count
          }
        })
      }
    });

    this.component.props.dispatch({
      type: Constants.PAGE_DASHBOARD_UPDATE_SWITCH_TAB,
      payload: {
        index: selectedTabIndexSession
      }
    });

    this.component.setState({
      activeTab: selectedTabIndexSession,
      value: selectedTabIndexSession,
    });

    const postProcessMessage = this.component.props.app.postProcessMessage;

    if (postProcessMessage) {
      this.component.setState({
        postProcessMessage: postProcessMessage,
        postProcessPopupOpen: true
      });

      this.component.props.dispatch({
        type: Constants.POST_PROCESS_MESSAGE_CLEAR
      });
    }
  }
}

export default new DashboardWillMount();
